import { render, staticRenderFns } from "./ChatCardV2026.vue?vue&type=template&id=37360f90&scoped=true"
import script from "./ChatCardV2026.vue?vue&type=script&lang=js"
export * from "./ChatCardV2026.vue?vue&type=script&lang=js"
import style0 from "./ChatCardV2026.vue?vue&type=style&index=0&id=37360f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37360f90",
  null
  
)

export default component.exports